import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheDeveloppeurFrontEnd = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🖥️ Recruter un Développeur Front-End
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Développeur Front-End est responsable de la création de l’interface utilisateur d’une application web. Il traduit les maquettes graphiques en pages interactives, fluides et responsive, tout en garantissant performance, accessibilité et compatibilité multi-navigateurs. C’est lui qui donne vie au produit du côté visible par les utilisateurs.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Intégrer les maquettes UI/UX en HTML/CSS/JS</li>
          <li>Développer des composants interactifs (boutons, formulaires, animations…)</li>
          <li>Implémenter des frameworks modernes (React, Vue, Angular…)</li>
          <li>Optimiser les performances front (lazy loading, bundling, SEO technique)</li>
          <li>Assurer la compatibilité entre navigateurs et terminaux</li>
          <li>Travailler en lien étroit avec les designers, back-end et PO</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Langages : HTML5, CSS3, JavaScript/TypeScript</li>
          <li>Frameworks : React, Vue.js, Angular (selon spécialisation)</li>
          <li>Outils : Git, Webpack, Vite, Figma, Storybook</li>
          <li>Responsive design, SEO, accessibilité (WCAG)</li>
          <li>Bonnes pratiques UI/UX et performances front-end</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : bonne intégration, développement de composants simples</li>
          <li>Confirmé : projets complets, interactions complexes, animations</li>
          <li>Senior : architecture front, atomic design, performance, audit d’UI</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 300–400 € / jour</li>
          <li>Confirmé : 450–600 € / jour</li>
          <li>Senior : 650–800 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheDeveloppeurFrontEnd;
